import React, {useEffect} from "react";
import {LocationForm, LocationRequestPartial, WorkingHoursRequest} from "./createAndUpdate/LocationForm";
import {
    clearCreateLocationState,
    createLocation,
    createLocationErrorMessageSelector,
    createLocationRequestSelector,
    createLocationRequestStatusSelector,
    updateAftersalesWorkingHours,
    updateCreateLocationRequest,
    updateWorkingHours
} from "../locationCreateSlice";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {fetchLocationList} from "../locationListSlice";
import {createLocationRequestPropertySelector} from "./selector/LocationStoreSelector";
import {RequestStatus} from "../../../../api/apiConfiguration";
import {
    showErrorToastNotification,
    showSuccessToastNotification
} from "../../../elements/toastNotification/toastNotificationSlice";

interface CreateLocationFormProps {
    handleClose: () => void
}

export const CreateLocationForm: React.FC<CreateLocationFormProps> = ({handleClose}) => {

    const dispatch = useAppDispatch()
    const createLocationRequestStatus = useAppSelector(createLocationRequestStatusSelector)
    const errorMessage = useAppSelector(createLocationErrorMessageSelector)

    useEffect(() => {
        return () => {
            dispatch(clearCreateLocationState());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (createLocationRequestStatus === RequestStatus.RESOLVED) {
            dispatch(fetchLocationList())
            handleClose()
            dispatch(showSuccessToastNotification({message: "Location Created Successfully"}))
        } else if (createLocationRequestStatus === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message: errorMessage || "Failed to create location"}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createLocationRequestStatus]);

    const handleUpdateWorkingHours = (update: WorkingHoursRequest & { fieldName: string }) => {
        dispatch(updateWorkingHours(update));
    }

    const handleUpdateAftersalesWorkingHours = (update: WorkingHoursRequest & { fieldName: string }) => {
        dispatch(updateAftersalesWorkingHours(update));
    }

    const updateRequest = (update: LocationRequestPartial) => {
        dispatch(updateCreateLocationRequest(update))
    }

    const onSubmit = () => {
        dispatch(createLocation())
    }

    return <LocationForm
        formTitle={"Create location"}
        onClose={handleClose}
        onSubmit={onSubmit}
        updateRequest={updateRequest}
        selectionProvider={createLocationRequestPropertySelector(createLocationRequestSelector)}
        updateWorkingHours={handleUpdateWorkingHours}
        updateAftersalesWorkingHours={handleUpdateAftersalesWorkingHours}
    />
}
